import store from '@/store';
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getTranslationSheet } from '@/api/google/sheet.js'
// import i18n from '@/plugins/vue-i18n';
// console.log(i18n.t('FOOTER.ITEM.MANUAL'));
/**
 * @interface Route
 *
 * @param { String } icon - mdi icon
 * @param { String } customIcon - custom svg icons added at '@/icons'
 * @param { String } name - route name
 * @param { String } path - path for route
 * @param { Boolean } hidden - visibility in drawer by style display
 * @param { Boolean } dontExist - visibility in drawer by VNode life cycle
 * @param { Array<Route> } children - children route
 * @param { Boolean } disabled - won't push route when true
 * @param { Boolean } expandable - expandable
 * @param { String } grant - visibility by grant
 */

const originRoutes = [
  {
    icon: '',
    text: '',
    name: '',
    path: '/',
    component: () => import('../page/index.vue'),
    redirect: '/exhibitions',
    hidden: true,
    grant: true,
    expand: true,
    children: [
      {
        icon: 'custom-web',
        text: '我的空間',
        i18nKey:'SIDEBAR.ITEM.MY_SPACE',
        path: '/exhibitions',
        grant: true,
        component: () => import('../page/exhibitions/route.vue'),
        expand: false,
        showPath:true,
        //component: () => import('../page/exhibitions/index.vue'),
        children: [
          {
            icon: 'custom-web',
            text: '我的空間',
            i18nKey:'SIDEBAR.ITEM.MY_SPACE',
            name: 'exhibitions',
            path: '/',
            grant: true,
            hidden: true,
            component: () => import('../page/exhibitions/index.vue'),
          },
          {
            icon: 'mdi-calendar-outline',
            text: '空間建立',
            name: 'exhibitions-create-new',
            path: 'create-new',
            hidden: true,
            grant: true,
            component: () => import('../page/exhibitions/create_space.vue')
          },
          {
            icon: 'mdi-calendar-outline',
            text: '空間建立',
            name: 'exhibitions-create',
            path: 'create',
            hidden: true,
            grant: true,
            component: () => import('../page/exhibitions/create.vue')
          },
          {
            icon: 'mdi-calendar-outline',
            text: '選擇空間主題',
            name: 'exhibitions-theme',
            path: 'theme',
            hidden: true,
            grant: true,
            component: () => import('../page/exhibitions/theme.vue')
          },
          {
            icon: 'mdi-calendar-outline',
            text: 'space',
            name: 'exhibitions-space',
            path: ':expoId/:status',
            hidden: true,
            grant: true,
            component: () => import('../page/exhibitions/_expoId/space.vue')
          },
          {
            icon: 'mdi-calendar-outline',
            text: '編輯作品',
            name: 'exhibitions-map',
            path: '/exhibitions/:expoId/map/',
            hidden: true,
            grant: true,
            component: () => import('../page/exhibitions/_expoId/edit.vue')
          },
        ]
      },
      // {
      //   icon: 'mdi-calendar-outline',
      //   text: '編輯展覽',
      //   name: 'exhibitions-edit',
      //   path: '/exhibitions/:expoId/edit/',
      //   hidden: true,
      //   grant: true,
      //   component: () => import('../page/exhibitions/_expoId/edit.vue')
      // },
      {
        icon: 'custom-folder',
        text: '創作者資訊',
        i18nKey:'SIDEBAR.ITEM.PERSONAL',
        name: 'creator-info',
        path: '/creator-info',
        grant: true,
        component: () => import('../page/creator-info/index.vue')
      },
      {
        icon: 'custom-payment',
        text: '升級方案',
        i18nKey:'SIDEBAR.ITEM.UPGRADE_PLAN',
        name: 'update-account',
        path: '/update-account',
        grant: true,
        component: () => import('../page/update-account/index.vue')
      },
      {
        icon: 'mdi-cog',
        text: '設定',
        name: 'account-setting',
        path: '/account-setting',
        hidden: true,
        grant: true,
        component: () => import('../page/account-setting/index.vue')
      },
      {
        icon: 'mdi-calendar-text-outline',
        text: '方案',
        name: 'plans',
        path: '/plans',
        grant: true,
        hidden: true,
        noDrawer: true,
        component: () => import('../page/plans/index.vue')
      },
      {
        icon: 'custom-money',
        text: '購買紀錄',
        name: 'buy-history',
        path: '/buy-history',
        hidden: true,
        grant: true,
        component: () => import('../page/buy-history/index.vue')
      }
    ]
  },
  {
    path: '*',
    name: 'pageNotFound',
    hidden: true,
    grant: true,
    component: () => import('../page/404.vue')
  }
];

export const filterByGrant = () => {
  const grants = store.getters['auth/getGrants'];

  const getGrantValue = (grantName) => {
    if (Array.isArray(grantName)) {
      const grantNames = grantName;
      return grantNames.some((_grantName) => {
        const grantSplit = _grantName.split('.');
        const name = grantSplit[0];
        const read = grantSplit[1];

        return grants[name][read];
      });
    } else if (typeof grantName === 'string') {
      const grantSplit = grantName.split('.');
      const name = grantSplit[0];
      const read = grantSplit[1];

      return grants[name][read];
    } else if (grantName === true) {
      return true;
    }
  };

  const recuresiveMap = (routes = originRoutes) => {
    return routes
      .map((_route) => {
        if (getGrantValue(_route.grant)) {
          if (_route.children && _route.children.length) {
            _route.children = recuresiveMap(_route.children);
          }

          return _route;
        }
      })
      .filter((v) => !!v);
  };

  return recuresiveMap();
};

export const routes = () =>
  process.env.VUE_APP_SHOW_GLOBAL_COMPONENT
    ? [
        ...filterByGrant(),
        {
          icon: 'mdi-scent',
          text: 'GlobalComponents',
          name: 'GlobalComponents',
          path: '/dev/global-components',
          component: () => import('../components/Globals/index.vue')
        }
      ]
    : filterByGrant();
